<!--
  Спринт 14 — «Куда прислать код?».

  Выбор здесь и есть действие: клик по кнопке отправляет код. Поэтому ни
  радиокнопок, ни отдельной кнопки «Продолжить» — предвыбор выражен тем, что
  первый канал нарисован основной кнопкой.

  Порядок кнопок задаёт бэкенд: первый элемент channels — предвыбранный.

  На экране только вопрос и варианты. Ничего про историю входов, память
  каналов и судьбу писем здесь быть не должно: человеку нужен код, а не
  рассказ о том, как мы принимаем решения.
-->
<template>
  <div class="otp-choice">
    <h2 class="otp-choice__title">{{ t('auth.otpChoice.title') }}</h2>

    <button
      v-for="(channel, index) in knownChannels"
      :key="channel"
      type="button"
      class="otp-choice__button"
      :class="{ 'otp-choice__button--primary': index === 0 }"
      :data-channel="channel"
      :disabled="busy"
      @click="pick(channel)"
    >
      {{ t(labels[channel]) }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type OtpChannel = 'telegram' | 'email'

const props = defineProps<{ channels: string[]; busy?: boolean }>()
const emit = defineEmits<{ (e: 'pick', channel: OtpChannel): void }>()

const { t } = useI18n()

const labels: Record<OtpChannel, string> = {
  telegram: 'auth.otpChoice.telegram',
  email: 'auth.otpChoice.email',
}

/**
 * Рисуем только те каналы, для которых у нас есть подпись. Кнопка без
 * подписи — это кнопка «неизвестно куда», нажимать её человеку незачем.
 */
const knownChannels = computed(
  () => props.channels.filter((channel): channel is OtpChannel => channel in labels)
)

function pick(channel: OtpChannel): void {
  if (props.busy) return
  emit('pick', channel)
}
</script>

<style scoped lang="scss">
.otp-choice {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.otp-choice__title {
  margin: 0 0 8px;
  text-align: center;
}

.otp-choice__button {
  padding: 14px 16px;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-card);
  background: transparent;
  color: var(--ds-text);
  font: inherit;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.otp-choice__button--primary {
  border-color: transparent;
  background: var(--ds-accent);
  color: var(--ds-text-on-accent);
  font-weight: var(--ds-weight-semibold);
}
</style>
